import Chip from "../../components/Chip";
import { AgentList, CompanyList, UsersList } from "../../types/General";
import { SHOW_USER_ROLES, USER_TYPE_SLUGS } from "../../utils/enums";

type props = {
  type: any;
  details: UsersList | CompanyList | AgentList | null;
};

const ProfileTop = ({ type, details }: props) => {
  return (
    <>
      <div className="cards profile_top">
        <div className="gap_p">
          <div className="left_s">
            <div className="profile_image">
              <figure>
                <img
                  src={
                    details?.profile_picture?.media_url ||
                    "/static/images/user_placeholder.png"
                  }
                  alt="Profile"
                />
                <span>
                  <img src="/static/images/verified_icon.svg" alt="Icon" />
                </span>
              </figure>
              <Chip
                label={type
                  ?.split("-") // Split by hyphen
                  ?.map(
                    (word: string) =>
                      word.charAt(0).toUpperCase() + word.slice(1)
                  )
                  ?.join(" ")}
                backgroundColor="#E8F5E9"
                color="#4CAF50"
                style={{ width: "100%", textAlign: "center" }}
              />
            </div>
            <div className="profile_info">
              <h2>
                <b>
                  {details?.first_name || "-"} {details?.middle_name}{" "}
                  {details?.last_name}
                </b>
              </h2>

              <ul className="text_list">
                <li>
                  <img src="/static/images/sms_icon.svg" alt="Icon" />{" "}
                  {details?.email ? (
                    <a
                      href={`mailto:${details?.email}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {details?.email}
                    </a>
                  ) : (
                    "-"
                  )}
                </li>
                <li>
                  <img src="/static/images/calling_icon.svg" alt="Icon" />{" "}
                  {details?.phone_no ? (
                    <a
                      href={`tel:${details?.country_code}${details?.phone_no}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {details?.country_code} {details?.phone_no}
                    </a>
                  ) : (
                    "-"
                  )}
                </li>
              </ul>
              {/* {type === USER_TYPE_SLUGS.INDIVIDUAL ? (
                <ul className="text_list">
                  {" "}
                  <li>Visa Type : {details?.visa_type || "-"}</li>
                  <li>Country : {details?.visa_for_country || "-"}</li>
                </ul>
              ) : null} */}

              {type === USER_TYPE_SLUGS.INDIVIDUAL ? null : (
                <ul className="box_list">
                  <li>
                    <h3 style={{ textAlign: "center" }}>
                      <img
                        src="/static/images/application.png"
                        alt="Icon"
                        style={{ maxWidth: "30px" }}
                      />{" "}
                      {details?.total_applicant || 0}
                    </h3>
                    <p>Number of Visa Requests</p>
                  </li>
                </ul>
              )}
            </div>
          </div>
          <div className="right_s">
            {type === USER_TYPE_SLUGS.INDIVIDUAL &&
            details?.registered_by_details ? (
              <div className="profile_image">
                <p style={{ color: "black", paddingBottom: "6px" }}>
                  Registered By
                </p>
                <figure>
                  <img
                    src={
                      details?.registered_by_details?.rep_profile_picture
                        ?.media_url || "/static/images/dummy-company.avif"
                    }
                    alt="Profile"
                  />
                </figure>
                <p>{details?.registered_by_details?.rep_email || ""}</p>
                <p>
                  (
                  {details?.registered_by_details?.role
                    ? Number(details?.registered_by_details?.role) === 6
                      ? "Company Representative"
                      : SHOW_USER_ROLES[
                          Number(details?.registered_by_details?.role)
                        ]
                    : "-"}
                  )
                </p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileTop;
